/**
 * TanStack Query hooks for `meta-conversions-api-capi-server-side-forwarding`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	metaConversionsApiCapiServerSideForwardingQueryKeys,
	type CreateMetaConversionsApiCapiServerSideForwardingBody,
	type ListMetaConversionsApiCapiServerSideForwardingResponse,
	type MetaConversionsApiCapiServerSideForwardingRow,
} from "./api";

export function useMetaConversionsApiCapiServerSideForwardingList(): UseQueryResult<ListMetaConversionsApiCapiServerSideForwardingResponse, Error> {
	return useQuery({
		queryKey: metaConversionsApiCapiServerSideForwardingQueryKeys.list(),
		queryFn: list,
	});
}

export function useMetaConversionsApiCapiServerSideForwardingCreate(): UseMutationResult<MetaConversionsApiCapiServerSideForwardingRow, Error, CreateMetaConversionsApiCapiServerSideForwardingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: metaConversionsApiCapiServerSideForwardingQueryKeys.all });
		},
	});
}

export function useMetaConversionsApiCapiServerSideForwardingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: metaConversionsApiCapiServerSideForwardingQueryKeys.all });
		},
	});
}
